import styled from 'styled-components';

export const Container = styled.div`
  .icon-wrapper {
    background-color: #f2f6f9;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .img-with-wrapper {
    display: inline-block;
    width: 44px;
  }
`;
